export var QuickbooksSettingId;
(function (QuickbooksSettingId) {
    QuickbooksSettingId[QuickbooksSettingId["CONTROL_INVOICE_REFERENCE"] = 0] = "CONTROL_INVOICE_REFERENCE";
    QuickbooksSettingId[QuickbooksSettingId["USE_PRODUCT_SERVICE_DESCRIPTIONS"] = 1] = "USE_PRODUCT_SERVICE_DESCRIPTIONS";
    QuickbooksSettingId[QuickbooksSettingId["INCLUDE_PROJECT_NAME_IN_DESCRIPTION"] = 2] = "INCLUDE_PROJECT_NAME_IN_DESCRIPTION";
    QuickbooksSettingId[QuickbooksSettingId["USE_QUICKBOOKS_TERMS"] = 3] = "USE_QUICKBOOKS_TERMS";
    QuickbooksSettingId[QuickbooksSettingId["USE_CUSTOMER_DEFAULT_TAX"] = 4] = "USE_CUSTOMER_DEFAULT_TAX";
})(QuickbooksSettingId || (QuickbooksSettingId = {}));
